import type { UserRole } from '@/shared/types/tables';
import { Badge, type BadgeTone } from '@/shared/ui';

const ROLE_TONE: Record<UserRole, BadgeTone> = {
  admin: 'amber',
  writer: 'sky',
  reader: 'violet',
};

export function RoleBadge({ role, className }: { role: UserRole; className?: string }) {
  return (
    <Badge tone={ROLE_TONE[role]} className={className}>
      {role}
    </Badge>
  );
}
